import { partnerIdSearchParamName } from '../../../pages/users/helpers.ts';
import { Path } from '../../enums/index.ts';

export const NAV_HELPERS = {
  /** Builds the route to a campaign identified by its printed code. */
  coupon: (couponId: string) => `${Path.Coupons}/${encodeURIComponent(couponId)}`,
  /** Opens the campaign metadata edit form. */
  couponEdit: (couponId: string) => `${NAV_HELPERS.coupon(couponId)}/edit`,
  /** Opens the campaign locking confirmation dialog. */
  couponDeactivate: (couponId: string) => `${NAV_HELPERS.coupon(couponId)}/deactivate`,
  /** Opens the campaign unlocking confirmation dialog. */
  couponActivate: (couponId: string) => `${NAV_HELPERS.coupon(couponId)}/activate`,
  partner: (partnerId?: string) => `${Path.Partners}/${partnerId}`,
  partnerEdit: (partnerId?: string) => `${Path.Partners}/${partnerId}/edit`,
  searchCourse: () => Path.SearchCourse,
  addCourse: (idCourse?: string) => `${Path.SearchCourse}/${idCourse}`,
  course: (courseId?: string) => `${Path.Courses}/${courseId}`,
  courseEdit: (courseId?: string) => `${Path.Courses}/${courseId}/edit`,
  courseDrivingRange: (courseId?: string) => `${Path.Courses}/${courseId}?view=driving`,
  hole: (courseId: string, holeId: string) => NAV_HELPERS.course(courseId) + `/holes/${holeId}`,
  document: (documentSlug: string) => `/document/${documentSlug}`,
  player: (playerId: string) => `${Path.Players}/${playerId}`,
  gameInfo: (gameId: string) => `${Path.Gameplay}/${gameId}`,
  user: (userId: string) => `${Path.Users}/${userId}`,
  device: (deviceId: string) => `${Path.Devices}/${deviceId}`,

  usersListByPartnerId: (partnerId?: string) =>
    `${Path.Users}/?${partnerIdSearchParamName}=${partnerId}`,
};
